/* The supplied Figma frames place this group on opposite sides of Speaking & Writing. */
if (!customElements.get('practice-showcase')) {
  class PracticeShowcase extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-responsive-order')) return;
      this.media = window.matchMedia('(max-width: 749px)');
      this.onChange = () => this.updateOrder();
      this.media.addEventListener('change', this.onChange);
      document.addEventListener('shopify:section:load', this.onChange);
      this.updateOrder();
    }

    disconnectedCallback() {
      this.media?.removeEventListener('change', this.onChange);
      document.removeEventListener('shopify:section:load', this.onChange);
    }

    updateOrder() {
      const wrapper = this.closest('.shopify-section');
      const main = wrapper?.parentElement;
      const speaking = main?.querySelector('.speaking-writing')?.closest('.shopify-section');
      if (!speaking || speaking.parentElement !== main) return;
      // Already adjacent: avoid repeated custom-element disconnect/connect callbacks.
      if (this.media.matches && wrapper.nextElementSibling !== speaking) {
        main.insertBefore(wrapper, speaking);
      } else if (!this.media.matches && speaking.nextElementSibling !== wrapper) {
        main.insertBefore(wrapper, speaking.nextSibling);
      }
    }
  }
  customElements.define('practice-showcase', PracticeShowcase);
}
